var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<section class="item"> <a id="'+
((__t=( name.toLowerCase().replace('&', '').replace('.', '').replace(' ', '') ))==null?'':__t)+
'"></a> <div class="main-content-with-padding"> <div class="contain spaced-row row"> <div class="container--score"> ';
 if (total_difference>0) { 
__p+=' <span class="positive"> +'+
((__t=( total_difference ))==null?'':__t)+
' </span> ';
 } 
__p+=' ';
 if (total_difference<0) { 
__p+=' <span class="negative"> '+
((__t=( total_difference ))==null?'':__t)+
' </span> ';
 } 
__p+=' ';
 if (total_difference==0) { 
__p+=' <span class="zero"> '+
((__t=( total_difference ))==null?'':__t)+
' </span> ';
 } 
__p+=' </div> <div class="container--title"> <h2>'+
((__t=( name ))==null?'':__t)+
'</h2> </div> <div class="container--body"> <p>'+
((__t=( description ))==null?'':__t)+
'</p> <a href="#top"><i class="fa fa-angle-double-up" aria-hidden="true"></i></a> </div> </div> </div> </section>';
}
return __p;
};
